import { DAPI_HOST } from '../../config/index';

const getUserAccountsUrl = () => `${DAPI_HOST}/v1/accounts`;
const getUserAccountUrl = (id: string) => `${DAPI_HOST}/v1/accounts/${id}`;

export { getUserAccountsUrl, getUserAccountUrl };
